/**
 * Performance debugging utilities
 * Use these in development to monitor memory and performance
 */
/**
 * Monitor memory usage
 */
export var debugMemory = function () {
    var perf = performance;
    if (perf.memory) {
        var used = (perf.memory.usedJSHeapSize / 1048576).toFixed(2);
        var total = (perf.memory.totalJSHeapSize / 1048576).toFixed(2);
        var limit = (perf.memory.jsHeapSizeLimit / 1048576).toFixed(2);
        console.log('=== Memory Usage ===');
        console.log("Used: ".concat(used, " MB"));
        console.log("Total: ".concat(total, " MB"));
        console.log("Limit: ".concat(limit, " MB"));
        return { used: used, total: total, limit: limit };
    }
    console.warn('performance.memory is not available');
    return null;
};
/**
 * Monitor event listeners (requires Chrome DevTools)
 */
export var debugListeners = function () {
    if (typeof window.getEventListeners === 'function') {
        var events = ['mousedown', 'mousemove', 'mouseup', 'resize', 'scroll'];
        console.log('=== Event Listeners ===');
        events.forEach(function (event) {
            var _a;
            var listeners = window.getEventListeners(window);
            var count = ((_a = listeners[event]) === null || _a === void 0 ? void 0 : _a.length) || 0;
            console.log("".concat(event, ": ").concat(count));
        });
    }
    else {
        console.warn('getEventListeners is not available. Open Chrome DevTools first.');
    }
};
/**
 * Monitor React component render count
 */
export var debugRenderCount = function () {
    if (process.env.NODE_ENV === 'development') {
        console.log('=== Render Count ===');
        console.log('Use React DevTools Profiler to see render counts');
    }
};
/**
 * Start memory monitoring (logs every N seconds)
 */
export var startMemoryMonitoring = function (intervalSeconds) {
    if (intervalSeconds === void 0) { intervalSeconds = 5; }
    var interval = setInterval(function () {
        debugMemory();
    }, intervalSeconds * 1000);
    console.log("Memory monitoring started (every ".concat(intervalSeconds, "s). Call stopMemoryMonitoring() to stop."));
    return function () {
        clearInterval(interval);
        console.log('Memory monitoring stopped');
    };
};
/**
 * Performance mark/measure utilities
 */
export var performanceMark = {
    start: function (name) {
        if (performance.mark) {
            performance.mark("".concat(name, "-start"));
        }
    },
    end: function (name) {
        if (performance.mark && performance.measure) {
            performance.mark("".concat(name, "-end"));
            performance.measure(name, "".concat(name, "-start"), "".concat(name, "-end"));
            var measure = performance.getEntriesByName(name)[0];
            console.log("".concat(name, ": ").concat(measure.duration.toFixed(2), "ms"));
        }
    },
};
// Attach to window for easy access in console
if (typeof window !== 'undefined') {
    window.debugMemory = debugMemory;
    window.debugListeners = debugListeners;
    window.startMemoryMonitoring = startMemoryMonitoring;
    window.performanceMark = performanceMark;
}
